import React, {Component} from 'react';
import {Icon, Segment, List} from 'semantic-ui-react';

export default class Alerts extends Component {

    render() {

        const alerts = [
            {
                "id": "0",
                "fi": "Bank",
                "time": "Today",
                "message": "Your Bank account (...3423) is disconnected."
            },
            {
                "id": "1",
                "fi": "Bank",
                "time": "Today",
                "message": "Your Bank account (...2343) is disconnected."
            }
        ];

        return (
            <Segment.Group className='hooli-segment'>
                <Segment className='hooli-segment-top'>
                    <List>
                        <List.Item>
                            <List.Content floated='right'>
                                <a>Edit your alerts</a>
                            </List.Content>
                            <List.Header><h3 className='hooli-text-dark-blue'>ALERTS</h3></List.Header>
                        </List.Item>
                    </List>
                </Segment>
                {alerts.map(alert => (
                    <Segment key={alert.id}>
                        <List>
                            <List.Item>
                                <List.Content floated='right'>
                                    {/*<Image src='/img/x-small.png' size='mini' />*/}
                                    <Icon name='remove' color='blue'/>
                                </List.Content>
                                <List.Header>{alert.time}</List.Header>
                                <div className='hooli-text-grey hooli-text-light hooli-list-spacing'>{alert.message}</div>
                            </List.Item>
                        </List>
                    </Segment>
                ))}
                <Segment className='hooli-segment-bottom'/>
            </Segment.Group>
        )

    }

}
